import { render } from "./breadcrums.vue?vue&type=template&id=4051a0a0&scoped=true"
import script from "./breadcrums.vue?vue&type=script&lang=js"
export * from "./breadcrums.vue?vue&type=script&lang=js"

import "./breadcrums.vue?vue&type=style&index=0&id=4051a0a0&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4051a0a0"]])

export default __exports__